import React, { useState, useEffect } from 'react';

import { GoDash, GoPlus } from 'react-icons/go';

import * as S from './styles';

import { formateBrPrice } from '../../../../utils/formateBrPrice';
import { IProduct } from '../../../../interfaces/IProduct';

interface PizzaComponentProps {
  pizza: IProduct;
  setPizzaComponent: (cartPizzaComponent: {
    produto: IProduct;
    quantidade: number;
  }) => void;
  base: boolean;
  full: boolean;
  numSelectedFlavors: number;
  cartItem?: any;
}

const PizzaComponent: React.FC<PizzaComponentProps> = (props) => {
  const {
    pizza,
    setPizzaComponent,
    base,
    full,
    numSelectedFlavors,
    cartItem,
  } = props;

  const encontraNumeradorFracao = (decimal: number): number => {
    let numerador = 1;
    let denominador = 1;

    while (numerador / denominador !== decimal) {
      if (numerador === 20 || denominador === 20) break;

      if (numerador === denominador) {
        ++denominador;
        numerador = 1;
      } else {
        ++numerador;
      }
    }

    return numerador;
  };

  const [complementMin, setComplementMin] = useState(false);
  const [quantidade, setQuantidade] = useState(base ? 1 : 0);

  useEffect(() => {
    setPizzaComponent({ produto: pizza, quantidade });
    setComplementMin(!(quantidade > (base ? 1 : 0)));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [base, pizza, quantidade]);

  useEffect(() => {
    if (cartItem) {
      setQuantidade(encontraNumeradorFracao(cartItem.quantidade));
    } else {
      setQuantidade(base ? 1 : 0);
    }
  }, [base, cartItem]);

  const handleAdition = (): void => {
    setQuantidade(quantidade + 1);
  };

  const handleRemove = (): void => {
    if (quantidade > (base ? 1 : 0)) setQuantidade(quantidade - 1);
  };

  return (
    <S.ComplementItem>
      <div className="informations">
        <p>{pizza.name}</p>

        {pizza.grids[0].discount &&
        pizza.grids[0].discount.active &&
        pizza.grids[0].discount.currentStock == 0 ? (
          <p className="out__of__stock">Sem estoque</p>
        ) : (
          <div className="prices">
            <p className="new__value">
              {formateBrPrice(
                Number(
                  pizza.grids[0].discount?.active
                    ? pizza.grids[0].price.value - pizza.grids[0].discount.price
                    : pizza.grids[0].price.value,
                ),
              )}
            </p>

            {pizza.grids[0].discount?.active && (
              <p className="old__value">
                {formateBrPrice(Number(pizza.grids[0].price.value))}
              </p>
            )}
          </div>
        )}
      </div>
      <S.Quantity>
        <S.CustomIconButton
          size="small"
          disabled={complementMin}
          onClick={handleRemove}
        >
          <GoDash />
        </S.CustomIconButton>
        <label>{quantidade}</label>
        <S.CustomIconButton
          size="small"
          disabled={
            full ||
            (pizza.grids[0].stock &&
              pizza.grids[0].stock.active &&
              (quantidade + 1) / (numSelectedFlavors + 1) >
                pizza.grids[0].stock.currentStock)
          }
          onClick={handleAdition}
        >
          <GoPlus />
        </S.CustomIconButton>
      </S.Quantity>
    </S.ComplementItem>
  );
};

export default PizzaComponent;
